import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import Wrapper from "../../../components/TenantWrapper";
import title from "../../../components/title";
import { GetTenantInterestRequests } from "../../../redux/reducer/FlatInterestRequest";
import TenantPropertyConditionDialog from "../../../components/TenantPropertyConditionDialog";

// Past tenancies only — a current, still-active one is managed from "My Rent
// Flat" instead. This is where the before/after photos, any damage claim and
// the property review live once a tenancy has actually ended.
export default function RentalHistory() {
  title("Rental History");
  const dispatch = useDispatch();
  const open = useSelector((state) => state.sidebar.open);
  const { myRequests, loading } = useSelector((state) => state.flatInterest);

  const tenantId = localStorage.getItem("user_id") || localStorage.getItem("userId");

  const [dialogState, setDialogState] = useState({ open: false, request: null });

  useEffect(() => {
    if (tenantId) dispatch(GetTenantInterestRequests({ tenantId }));
  }, [dispatch, tenantId]);

  const pastTenancies = (myRequests || []).filter((r) => r.moveInStatus === "moved_out");

  return (
    <>
      <Wrapper open={open} />
      <Box className={`main-container ${open ? "sidebar-open" : "sidebar-closed"}`} sx={{ p: { xs: 2, md: 4 } }}>
        <Typography variant="h5" fontWeight={800} gutterBottom>
          Rental History
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Properties you've moved out of — view move-in/move-out photos, respond
          to any damage claim, and leave a review.
        </Typography>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
            <CircularProgress />
          </Box>
        ) : pastTenancies.length === 0 ? (
          <Alert severity="info">You don't have any past tenancies yet.</Alert>
        ) : (
          <Stack spacing={2}>
            {pastTenancies.map((r) => (
              <Paper
                key={r._id}
                elevation={0}
                sx={{ p: 2.5, border: "1px solid #e5e7eb", borderRadius: 2 }}
              >
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  flexWrap="wrap"
                  gap={1}
                >
                  <Box>
                    <Typography fontWeight={700}>{r.flatName}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {r.flatAddress}
                      {r.movedOutAt
                        ? ` — moved out ${new Date(r.movedOutAt).toLocaleDateString()}`
                        : ""}
                    </Typography>
                  </Box>
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<PhotoCameraIcon fontSize="small" />}
                    onClick={() => setDialogState({ open: true, request: r })}
                  >
                    Condition &amp; Review
                  </Button>
                </Stack>
              </Paper>
            ))}
          </Stack>
        )}
      </Box>

      <TenantPropertyConditionDialog
        open={dialogState.open}
        onClose={() => setDialogState({ open: false, request: null })}
        tenantId={tenantId}
        flatId={dialogState.request?.flatId}
        flatName={dialogState.request?.flatName}
      />
    </>
  );
}
